import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2,jkLib,dateFormatter, AgComboBoxEditor, jkRestReturn, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Stkwl } from '../entity/Stkwl-angular';


@Injectable({
  providedIn: 'root'
})
export class StkwlServicePkg extends JkEntityV2 { 


  constructor() {
    super();
    this.linkMasterFields = '' ; 
    this.defaultItem = new Stkwl(); 
    this.entityType.type = EntityType.data;
    this.columnLabel = { COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數', 
        WL001 : '單號' , WL002 : '序號' , WL003 : '排序碼' , WL004 : 'text內文' , WL005 : '日期' , WL006 : 'Date' , WL007 : '主旨' , WL008 : '星號' , WL009 : '來源單號' , WL010 : '股票代號' , WL011 : 'tag' , WL012 : '格式' , WL013 : 'html內文'  }; 

    this.fieldNames = 'WL001,WL002,WL003,WL004,WL005,WL006,WL007,WL008,WL009,WL010,WL011,WL012,WL013' ;
    this.fieldLengths = {WL001 : 20 ,WL002 : 4 ,WL003 : 4 ,WL004 : 1000 ,WL005 : 8 ,WL006 : 0 ,WL007 : 100 ,WL008 : 1 ,WL009 : 100 ,WL010 : 10 ,WL011 : 1 ,WL012 : 1 ,WL013 : 2000 } ;
    this.columnDefs = [
      { field: "WL008", headerName: "星號",headerTooltip: "",width:80,cellDataType: "text", cellRenderer: AgCheckBoxEditor,  },
      { field: "WL013", headerName: "html內文",headerTooltip: "",width:250,cellDataType: "text", cellEditor: 'agLargeTextCellEditor', cellRenderer: AgTextAreaEditor,  },
      { field: "WL012", headerName: "格式",headerTooltip: "",width:80,cellDataType: "text", },
      { field: "WL011", headerName: "tag",headerTooltip: "",width:80,cellDataType: "text", cellRenderer: AgCheckBoxEditor,  },
      { field: "WL010", headerName: "股票代號",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "WL009", headerName: "來源單號",headerTooltip: "",width:250,cellDataType: "text", },
      { field: "WL001", headerName: "單號",headerTooltip: "",width:230,cellDataType: "text", },
      { field: "WL007", headerName: "主旨",headerTooltip: "",width:250,cellDataType: "text", },
      { field: "WL006", headerName: "Date",headerTooltip: "",width:80,cellDataType: "date", valueFormatter: (p:any) => { return jkLib.datetimeFormatter(p.value)},  },
      { field: "WL005", headerName: "日期",headerTooltip: "",width:120,cellDataType: "text", valueFormatter: dateFormatter,  },
      { field: "WL004", headerName: "text內文",headerTooltip: "",width:250,cellDataType: "text", cellEditor: 'agLargeTextCellEditor', cellRenderer: AgTextAreaEditor,  },
      { field: "WL003", headerName: "排序碼",headerTooltip: "",width:102,cellDataType: "number", cellStyle: { 'text-align': 'right' },  },
      { field: "WL002", headerName: "序號",headerTooltip: "",width:102,cellDataType: "text", },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'STKWL' ;
    this.isSys =false; 
    this.sqlSelect = `SELECT STKWL.*  FROM STKWL` ;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1` ;
    this.sqlOrderDefault = ` ORDER BY WL001,WL002` ;
    this.keyFields = ['WL001','WL002'];
    this.url = '/db/crud'; 
    this.rememberFields = [];
    this.requiredFields = ['WL001','WL002'];
    this.seqField = 'WL002' ;
    this.seqFieldLength = 4 ;
  }
  override async validateItem(item: Stkwl): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }


}

